import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { ArrowRight, Ruler } from "lucide-react";
import { Button } from "@/components/ui/button";
import { estimateExteriorCleaning } from "@/lib/exterior-price-estimate";
import { SERVICE_BY_SLUG } from "@/lib/exterior-services";
import { supabase } from "@/integrations/supabase/client";

const money = (v: number) => new Intl.NumberFormat("en-GB", { style: "currency", currency: "GBP", maximumFractionDigits: 0 }).format(v);

/** In-article estimate for the service the article is about; hands off to the existing quote form. */
export function ArticleEstimate({ service }: { service: string }) {
  const info = SERVICE_BY_SLUG.get(service);
  const [signedIn, setSignedIn] = useState(false);
  useEffect(() => { void supabase.auth.getSession().then(({ data }) => setSignedIn(Boolean(data.session))); }, []);
  if (!info) return null;
  const estimate = estimateExteriorCleaning({ services: [service] });
  return <aside className="journal-estimate" aria-labelledby="journal-estimate-title">
    <p className="bws-eyebrow">YOUR ESTIMATE</p>
    <h2 id="journal-estimate-title">Get your {info.name.toLowerCase()} estimate</h2>
    <p className="journal-estimate-range" aria-live="polite">{money(estimate.low)}–{money(estimate.high)}</p>
    <p className="journal-estimate-note">Indicative starter range, before any measurements. No booking or payment.</p>
    {signedIn && <p className="journal-estimate-note"><Ruler size={14} aria-hidden /> Your saved property measurements will be filled in.</p>}
    <Button asChild><a href={`/quote?services=${encodeURIComponent(service)}`}>Refine my estimate <ArrowRight size={16} /></a></Button>
    <Link to="/quote" className="bws-text-link journal-estimate-alt">Something else?</Link>
  </aside>;
}
